import allocations from '../assets/module-icons/allocations.svg';
import inventory from '../assets/module-icons/inventory.svg';
import planningAssistant from '../assets/module-icons/planning-assistant.svg';
import replenishment from '../assets/module-icons/replenishment.svg';
import specialEvents from '../assets/module-icons/special-events.svg';
import storeTransfer from '../assets/module-icons/store-transfer.svg';
import analytics from '../assets/module-icons/analytics.svg';
import { ModuleNames } from './module-names';

export default {
  [ModuleNames.Allocations]: allocations,
  [ModuleNames.Analytics]: analytics,
  [ModuleNames.Inventory]: inventory,
  [ModuleNames.Replenishment]: replenishment,
  [ModuleNames.SpecialEvents]: specialEvents,
  [ModuleNames.StoreTransfer]: storeTransfer,
  [ModuleNames.PlanningAssistant]: planningAssistant,
  [ModuleNames.DataCenter]: null,
};
